export default "__VITE_ASSET__BhXOKsxB__"